import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  Tip,
  Tag,
  //StarRating,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
  Document,
  Gateway,
  Codepen,
  // StarRating,
  View,
} from "grommet-icons";
import axios from "axios";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
} from "./GlobalSettings";
import LiveDemoDetail from "./LiveDemoDetail";
import ContentDetailViewCard from "./ContentDetailViewCard";
import Rating from "@material-ui/lab/Rating";
import DatumContainer from "./DatumContainer";
import ScaleLoader from "react-spinners/ScaleLoader";

class DemoListViewCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Demo: this.props._demo,
      bShowDemoDetail: false,
      rateVal: 1,
      showLoaderRating: false,
    };
    this._showDemoDetail = this._showDemoDetail.bind(this);
    this._hideDemoDetail = this._hideDemoDetail.bind(this);
    this.setRating = this.setRating.bind(this);
    this.sanitizedContentDescription =
      this.sanitizedContentDescription.bind(this);
  }

  componentDidMount() {
    this.setState({ Demo: this.props._demo });
    console.log("DemoLV Component Did Mount called");
    // console.log("Rating Mounted with ", this.state.Demo);
  }

  componentDidUpdate() {
    //this.setState({ Demo: this.props._demo });
    console.log("DemoLV Component Did Update called");
  }

  sanitizedContentDescription(description) {
    return <div dangerouslySetInnerHTML={{ __html: description }} />;
  }

  _showDemoDetail() {
    //console.log("Show dmo Det clicked with data passed as ", data);
    this.setState({ bShowDemoDetail: true });
  }
  _hideDemoDetail() {
    this.setState({ bShowDemoDetail: false });
    this.props.hide();
    // this.props.RefreshCallback();
  }

  setRating(newRate, type, id, rating) {
    console.log("Rating Prop is ", this.props._demo);
    console.log("Rating new Values is ", newRate);
    console.log("Rating new Values Type ", type);
    console.log("Rating new Values ID ", id);
    console.log("Rating  Curent Rate is ", rating);

    if (newRate !== null) {
      // console.log("Rating content Index Val is ", this.props.indexval);

      // var tempdemoData  = this.state.Demo;
      var ActionType = "";
      if (
        this.props._demo.Content_Rating > 0 &&
        this.props._demo.Content_Rating !== null
      ) {
        ActionType = "Update";
      } else {
        ActionType = "Insert";
      }

      var RatingDataPost = {
        Rating_ID: null,
        ContentId: id,
        Rating_Value: newRate,
        Action_Type: ActionType,
        Content_Type: type,
      };

      var endpoint = "/AllContent/AddorUpdateRating";
      let token = auth.getToken();
      var postData = RatingDataPost;
      console.log("Rating Data is :", RatingDataPost);
      this.setState({ showLoaderRating: true });
      //start below
      callApiPostJson(endpoint, postData, token).then((data) => {
        console.log(
          "Profile result Rating insert update response from API:",
          data
        );
        if (data) {
          console.log("UpdateMessage back from Rating Call response is : ");
          console.log(data);

          //  this.props.hide();
          var tempdemoData = this.state.Demo;

          if (tempdemoData != undefined) {
            tempdemoData.Content_Rating = newRate;
            /*           tempdemoData.map((demoitem) => {
            if(demoitem.Content_ID == contentID){
              demoitem.Content_Rating = newRate;
            }
          }); */
            this.setState({ Demo: tempdemoData, showLoaderRating: false });
          }

          //this.setState({ Demo: tempdemoData, showLoaderRating: false });
          // auth.updateUserInfo(data);
          // this.props.hidenaa();
          // this.props.history.push("/home");
          //this.props.router.replace("/home");
        }
      });
    } else {
      console.log(
        "No Action - As rating value not changed from previous value"
      );
    }
  }

  // this.setState({ Demo: tempdemoData, showLoaderRating: false });
  // auth.updateUserInfo(data);
  //this.props.hide();
  // this.props.history.push("/home");
  //this.props.router.replace("/home");

  render() {
    // var _Demo = this.state.Demo ? this.state.Demo : this.props._demo;

    var _Demo = this.state.Demo ? this.state.Demo : this.props._demo; //this.props._demo;
    var bShowDetailPopup = false;
    bShowDetailPopup = this.state.bShowDemoDetail;
    var applicableDemo = undefined;
    // var raTingVal = this.state.rateVal;

    // console.log("From Demo Lists - State ", _Demo);
    console.log("From Demo Lists - Props ", this.props._demo);

    /* if (this.props.AllDemos) {
      applicableDemo = this.props.AllDemos.find(
        (dm) => dm.Content_ID === this.props._demo.Content_ID
      );
    } */

    var selColor = "green";

    if (this.props._type === "Live") {
      selColor = "green";
    }
    if (this.props._type === "Lab") {
      selColor = "graph-0";
    }
    if (this.props._type === "Interactive") {
      selColor = "graph-3";
    }

    const TipContent = ({ message }) => (
      <Box direction="row" align="center">
        <svg viewBox="0 0 22 22" version="1.1" width="22px" height="22px">
          <rect
            x="10"
            y="10"
            width="200"
            height="100"
            stroke="green"
            stroke-width="3"
            fill="white"
          />
          {/* <polygon
            stroke="red"
            stroke-width="6"
            fill="blue"
            // style="fill:white;stroke:green;stroke-width:3;"
            // fill="white"
            // stroke="green"
            points="6 2 18 12 6 22"
            transform="matrix(-1 0 0 1 30 0)"
          /> */}
        </svg>
        <Box background="grey" direction="row" pad="small" round="xsmall">
          <Text>{message}</Text>
        </Box>
      </Box>
    );

    //varIcon = "";

    return (
      /*       <Tip
        plain
        content={
          <Box
            pad="small"
            gap="small"
            width={{ max: "large" }}
            height={{ max: "large" }}
            round="small"
            background="background-front"
            border="all"
            responsive={false}
          >
            
            <Text size="small">
              {this.sanitizedContentDescription(_Demo.Content_Description)}
            </Text>
          </Box>
        }
        dropProps={{ align: { top: "bottom" } }}
      > */
      <Tip
        plain
        content={
          <Box
            pad="small"
            gap="small"
            width={{ max: "large" }}
            height={{ max: "large" }}
            round="small"
            background="background-front"
            border="all"
            responsive={false}
          >
            <Text size="small">{_Demo.Content_Title}</Text>
          </Box>
        }
        dropProps={{ align: { right: "left" } }}
      >
        <Card
          pad="xsmall"
          justify="between"
          height="small"
          background={{ color: "white" }}
        >
          <Box
            align="stretch"
            justify="start"
            direction="row"
            responsive={false}
            pad="xsmall"
            gap="xsmall"
            round="xsmall"
            background={{ opacity: "medium" }}
          >
            <Box align="center" justify="start" direction="column">
              <Text weight="bold" color="black" truncate={true} size="medium">
                {_Demo.Content_Title}
              </Text>
            </Box>
          </Box>
          <Box
            align="stretch"
            justify="between"
            direction="row"
            responsive={false}
            pad="xsmall"
          >
            {_Demo.Content_Type === "Physical" && (
              <Box
                // pad="small"
                // border={{ color: "brand", size: "small" }}
                round
                alignSelf="start"
              >
                {_Demo.PhyContent_Category !== null &&
                  _Demo.PhyContent_Category == "Live" && (
                    <Box direction="row">
                      <Console size="large" color="brand" />
                      <Text
                        size="large"
                        // weight="bold"
                        margin={{ left: "xsmall", top: "xsmall" }}
                      >
                        {_Demo.PhyContent_Category}
                      </Text>
                    </Box>
                  )}
                {_Demo.PhyContent_Category !== null &&
                  _Demo.PhyContent_Category == "Lab" && (
                    <Box direction="row">
                      <Codepen size="large" color="blue!" />
                      <Text
                        size="large"
                        // weight="bold"
                        margin={{ left: "xsmall", top: "xsmall" }}
                      >
                        {_Demo.PhyContent_Category}
                      </Text>
                    </Box>
                  )}
                {_Demo.PhyContent_Category !== null &&
                  _Demo.PhyContent_Category == "Interactive" && (
                    <Box direction="row">
                      <Gateway size="large" color="purple!" />
                      <Text
                        size="large"
                        // weight="bold"
                        margin={{ left: "xsmall", top: "xsmall" }}
                      >
                        {_Demo.PhyContent_Category}
                      </Text>
                    </Box>
                  )}
                {/*  {_Demo.PhyContent_Category !== null
                ? _Demo.PhyContent_Category
                : "Live - Demo"} */}
              </Box>
            )}
            {_Demo.Content_Type === "Multimedia" && (
              <Box direction="row">
                <Video size="large" color="blue" />
                <Text
                  size="large"
                  // weight="bold"
                  margin={{ left: "xsmall", top: "xsmall" }}
                >
                  {"Video"}
                </Text>
              </Box>
            )}
            {_Demo.Content_Type === "Document" && (
              <Box direction="row">
                <DocumentPdf size="large" color="dark-3" />
                <Text
                  size="large"
                  // weight="bold"
                  margin={{ left: "xsmall", top: "xsmall" }}
                >
                  {"Document"}
                </Text>
              </Box>
            )}
            <Box
              // pad="small"
              //  border={{ color: "brand", size: "small" }}
              round
              alignSelf="start"
            >
              {_Demo.Content_ExpertiseLevel
                ? _Demo.Content_ExpertiseLevel.ExpertLevelName
                : "No Expertise"}
            </Box>
          </Box>
          <Box
            align="stretch"
            justify="between"
            direction="row"
            responsive={false}
            pad="xsmall"
            margin={{ top: "small", bottom: "small" }}
            // onClick={() => {
            //   push("/listview---cards---copy");
            // }}
          >
            {_Demo.Content_Type == "Multimedia" && (
              <Button
                label="Open"
                size="large"
                // icon={<Video />}
                color="brand"
                hoverIndicator
                primary
                onClick={this._showDemoDetail}
              />
            )}
            {_Demo.Content_Type == "Physical" && (
              <Button
                label="Launch"
                // icon={<Console />}
                size="large"
                color="brand"
                // background="brand"
                hoverIndicator
                primary
                onClick={this._showDemoDetail}
              />
            )}
            {_Demo.Content_Type == "Document" && (
              <Button
                label="Details"
                //icon={<Document />}
                size="large"
                color="brand"
                // background="brand"
                hoverIndicator
                primary
                onClick={this._showDemoDetail}
              />
            )}
            {this.state.showLoaderRating &&
              this.props._demo.Content_Type != "Document" && (
                <ScaleLoader
                  color="#008000"
                  height={20}
                  speedMultiplier={2}
                  width={5}
                />
              )}
            {!this.state.showLoaderRating &&
              this.props._demo.Content_Type != "Document" && (
                <Rating
                  name={this.props._demo.Content_ID}
                  style={{ color: "green" }}
                  value={_Demo.Content_Rating} //{this.props._demo.Content_Rating}
                  onChange={(event, newvalue) => {
                    this.setRating(
                      newvalue,
                      this.props._demo.Content_Type,
                      this.props._demo.Content_ID,
                      this.props._demo.Content_Rating
                    );
                  }}
                />
              )}
            {/* <StarRating /> */}
            {bShowDetailPopup && (
              <ContentDetailViewCard
                _demoData={_Demo}
                hide={this._hideDemoDetail}
                calledBy={this.props.calledBy}
              />
            )}
          </Box>
        </Card>
      </Tip>
    );
  }
}

export default DemoListViewCard;
